import React from 'react'
import PropTypes from 'prop-types'
import moment from 'moment'
import { Link } from 'react-router-dom'
import { Row, Col } from 'reactstrap'
import FieldsetItem from 'components/FieldsetItem'
import { Skus } from './constants'
import CsvDownloadLink from 'components/CsvDownloadLink'
import { IsRosteredBadge } from 'components/IsRosteredBadge/IsRosteredBadge'
import {
  Expiration,
  LicenseHeader,
  LicenseName,
  LicenseRow,
  ReportLink,
  ReportLinkWrapper,
} from './component.styles'
import {
  DOWNLOAD_LESSON_REPORT_TEXT,
  PREPARING_LESSON_REPORT_TEXT,
} from '../../containers/css-admin/licenses/LicenseHeader/constants'

const SiteSummary = ({
  fetchLessonProgressReport,
  fetchTrainingReport,
  isFetchingReports,
  site,
  siteUsers = [],
  reports,
}) => {
  const {
    createdDate,
    id,
    isRostered,
    licenses,
    modifiedDate,
    name,
    netSuiteCustomer,
    organization,
  } = site || {}
  const { companyName, nsCustomerId } = netSuiteCustomer || {}
  const { id: orgId, name: orgName } = organization || {}
  const siteUserEmails =
    siteUsers && siteUsers.map(siteUser => siteUser.inviteEmail)

  return (
    <fieldset>
      <legend>Details</legend>
      <Row>
        <Col sm={4}>
          <FieldsetItem data={nsCustomerId} title="Site NS Customer Id" />
          <FieldsetItem data={orgId} title="SecondStep Organization Id" />
        </Col>
        <Col sm={5}>
          <FieldsetItem data={name} title="Site Name" />
          <FieldsetItem
            data={companyName}
            title="Site NetSuite Customer Name"
          />
          <FieldsetItem data={orgName} title="SecondStep Organization Name" />
        </Col>
        <Col sm={3}>
          <FieldsetItem
            data={moment(createdDate).format('YYYY-MM-DD')}
            color="none"
            title="Created Date"
          />
          <FieldsetItem
            color="none"
            data={moment(modifiedDate).format('YYYY-MM-DD')}
            title="Modified Date"
          />
          <FieldsetItem color="none" title="Is Rostered">
            <IsRosteredBadge isRostered={isRostered} summaryView={true} />
          </FieldsetItem>
        </Col>
      </Row>
      <LicenseHeader>Licenses</LicenseHeader>
      {licenses.length > 0 ? (
        licenses.map((license, index) => {
          if (license.isExpired || license.isCancelled) return
          const licenseSummary = `${license.product.description}, ${license.product.duration}-Year License, ID:${license.nsLicenseId}`
          const formattedDate = new Date(
            license.expirationDate,
          ).toLocaleDateString('en-us', {
            year: 'numeric',
            month: 'long',
            day: 'numeric',
          })
          const { product } = license || {}
          let { skuCode } = product || {}
          skuCode =
            skuCode === Skus.MSPSkuCode ||
            skuCode === Skus.K5SkuCode ||
            skuCode === Skus.K8FamilySkuCode ||
            skuCode === Skus.K12SkuCode ||
            skuCode === Skus.K8SkuCode
              ? Skus.K8SkuCode
              : skuCode.toUpperCase()

          const licenseReport = reports[skuCode]
          const isFetchingReport = isFetchingReports[skuCode]
          let data, filename, headers, reportUrl
          if (skuCode === Skus.K8SkuCode) reportUrl = licenseReport
          if (skuCode === Skus.CPUSkuCode || skuCode === Skus.BPUSkuCode) {
            ;({ data, filename, headers } = licenseReport || {})
          }
          const progressReportLinkText = isFetchingReport
            ? PREPARING_LESSON_REPORT_TEXT
            : DOWNLOAD_LESSON_REPORT_TEXT

          return (
            <Row index={index} key={license.id}>
              <Col sm={12}>
                <LicenseRow>
                  <LicenseName>
                    <Link to={`/css-admin/licenses/${license.id}`}>
                      {licenseSummary}
                    </Link>
                  </LicenseName>
                  <Expiration>{`Expire${
                    license.isExpired ? 'd' : 's'
                  } ${formattedDate}`}</Expiration>
                  {skuCode && skuCode !== Skus.ADLSkuCode && (
                    <ReportLinkWrapper>
                      {(licenseReport === null || isFetchingReport) && (
                        <ReportLink
                          dataTestId="get-lesson-progress-report-link"
                          disabled={isFetchingReport}
                          onClick={() => {
                            if (
                              skuCode === Skus.CPUSkuCode ||
                              skuCode === Skus.BPUSkuCode
                            ) {
                              fetchTrainingReport(siteUserEmails, skuCode, name)
                            } else {
                              fetchLessonProgressReport(site.id, skuCode)
                            }
                          }}
                        >
                          {progressReportLinkText}
                        </ReportLink>
                      )}
                      {data &&
                        data.length &&
                        (skuCode === Skus.CPUSkuCode ||
                          skuCode === Skus.BPUSkuCode) && (
                          <CsvDownloadLink
                            data={data}
                            filename={filename}
                            headers={headers}
                          >
                            {DOWNLOAD_LESSON_REPORT_TEXT}
                          </CsvDownloadLink>
                        )}
                      {reportUrl && skuCode === Skus.K8SkuCode && (
                        <a href={reportUrl}>{DOWNLOAD_LESSON_REPORT_TEXT}</a>
                      )}
                    </ReportLinkWrapper>
                  )}
                </LicenseRow>
              </Col>
            </Row>
          )
        })
      ) : (
        <div>Site Has No Licenses</div>
      )}
    </fieldset>
  )
}

SiteSummary.propTypes = {
  fetchLessonProgressReport: PropTypes.func.isRequired,
  isFetchingReports: PropTypes.object.isRequired,
  site: PropTypes.object.isRequired,
  reports: PropTypes.object.isRequired,
}

export default SiteSummary



// WEBPACK FOOTER //
// ./src/components/SiteSummary/component.js